import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChatJSLineGraph } from "../../../../Constant";
import { Line } from "react-chartjs-2";
import { LINE_GRAPH_CHART, LINE_GRAPH_OPTION } from "../../../../Data/Charts/ChartJS";

const LineGraph = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSLineGraph} />
        <CardBody className="chart-block">
            <Line id="myGraph" data={LINE_GRAPH_CHART} options={LINE_GRAPH_OPTION} width={778} height={400} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineGraph;
